import React, { Component } from "react";
import { Link } from 'react-router-dom';
import {FaTwitter ,FaInstagram ,FaFacebookF , FaLinkedinIn} from "react-icons/fa";
import ReactPlayer from "react-player";

//const logoUrl = <img src="/assets/images/logo/logo-light.png" alt="Digital Agency" />;
const logoUrl = <img src="/assets/images/footer/logo.gif" alt="Digital Agency" />;

const videoLogoUrl = "/assets/images/footer/footer_logosheenclip.mp4";

const SocialShare = [
    {Social: <FaFacebookF /> , link: 'https://www.facebook.com/Solutoz'},
    {Social: <FaLinkedinIn /> , link: 'https://www.linkedin.com/company/solutoz'},
    {Social: <FaInstagram /> , link: 'https://www.instagram.com/teamsolutoz/'},
    {Social: <FaTwitter /> , link: 'https://twitter.com/solutoz'},
]

class Footer extends Component{
    render(){
        return(
            <React.Fragment>
                <footer className="footer-area footer-style-01 bg_color--11">

                    {/* Start Footer Area  */}
                    <div className="footer-wrapper ptb--70">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                    <div className="ft-text">
                                    {/*<div>
                                      <iframe src="/assets/images/footer/logoclip.mp4" width="200" height="150" frameBorder="0" allow="autoplay" scrolling="no"/>
                                      <video width="120" height="120" autoplay muted loop   >
                                        <source src="/assets/images/footer/sample-5s.mp4" type="video/mp4"/>
                                      </video>
                                    </div>*/}
                                   <div className="logo">
                                          <a href="/">
                                            {logoUrl}
                                          </a>
                                        </div>


                                        <p>Copyright © 2021 <a href="/">Solutoz Private Limited</a> </p>
                                    </div>
                                </div>

                                {/* Start Single Widget  */}
                                <div className="col-lg-2 col-xl-2 offset-xl-1 col-md-6 col-sm-6 col-12 mt_mobile--40">
                                    <div className="footer-link">
                                        <h4>Quick Link</h4>
                                        <ul className="ft-link">
                                            <li><a href="./#about">About</a></li>
                                            <li><a href="./#team">Our Team</a></li>
                                            <li><Link to="/contact">Contact</Link></li>
                                        </ul>
                                    </div>
                                </div>
                                {/* End Single Widget  */}

                                {/* Start Single Widget  */}
                                <div className="col-lg-3 col-md-6 col-sm-6 col-12 mt_md--40 mt_sm--40">
                                    <div className="footer-link">
                                        <h4>Say Hello</h4>
                                        <ul className="ft-link">
                                            <li>Email: <a href="mailto:info@solutoz.com">info@solutoz.com</a></li>
                                            <li>Phone: <a>+91-9108197585</a></li>
                                        </ul>

                                        <div className="social-share-inner mt--20">
                                            <ul className="social-share social-style--2 d-flex justify-content-start liststyle">
                                                {SocialShare.map((val , i) => (
                                                    <li key={i}><a href={`${val.link}`} target="_blank">{val.Social}</a></li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                {/* End Single Widget  */}
                            </div>
                        </div>
                    </div>
                    {/* End Footer Area  */}
                </footer>
            </React.Fragment>
        )
    }
}
export default Footer;
